/**
 * La telemetría de producto, según el entorno. UN SOLO SITIO para sus
 * variables, como `api-routes.ts` para el API.
 *
 * Todas se hornean al compilar (§12). Sin URL o sin write key no hay
 * telemetría: ni cliente ni una sola petición. Es lo que pasa en las pruebas y
 * en la CI de los PR, que compilan sin estas variables.
 */

/**
 * El gateway de lala-ms, sin barra final. El SDK le añade
 * `/api/telemetry/v1/collect`. Local: `http://localhost:4000`.
 */
const TELEMETRY_URL: string = (
  import.meta.env.VITE_TELEMETRY_URL ?? ""
).replace(/\/+$/, "");

/**
 * La write key de la source `embajadores-admin`: el backend deriva la source
 * de ella. No es un secreto --viaja en cada petición del navegador--, pero se
 * lee de Secret Manager al compilar para no dejarla en el repo.
 */
const TELEMETRY_WRITE_KEY: string =
  import.meta.env.VITE_TELEMETRY_WRITE_KEY ?? "";

export interface TelemetrySettings {
  readonly gatewayUrl: string;
  readonly writeKey: string;
  /** Los logs del SDK en la consola (`[telemetry-sdk]`). */
  readonly debug: boolean;
}

/**
 * La configuración del cliente, o `null` si no hay telemetría.
 *
 * Las pruebas nunca la tienen: aunque el `.env` local traiga las variables,
 * vitest compila en modo `test` y ahí una prueba no manda nada a nadie. Quien
 * quiera ver eventos en una prueba sustituye el cliente.
 */
export const telemetrySettings: TelemetrySettings | null =
  import.meta.env.MODE === "test" ||
  TELEMETRY_URL === "" ||
  TELEMETRY_WRITE_KEY === ""
    ? null
    : {
        gatewayUrl: TELEMETRY_URL,
        writeKey: TELEMETRY_WRITE_KEY,
        debug: import.meta.env.VITE_TELEMETRY_DEBUG === "true",
      };

/** Nombre de la aplicación en las propiedades base de cada evento. */
export const TELEMETRY_APP = "embajadores-web";

/** El entorno del build: `development` en local, `production` en el deploy. */
export const TELEMETRY_ENV: string = import.meta.env.MODE;

/** El commit que se desplegó (`github.sha`); en local, `dev`. */
export const APP_VERSION: string = import.meta.env.VITE_APP_VERSION ?? "dev";
